import React, { useState, useEffect, useContext } from 'react'
import styles from "./DetalleDeclaracionJurada.module.css"
import GeneralContext from "../../context/GeneralContext"
import * as Globales from "../../utils/globales"
import DetalleSubPreguntaDJ from '../DetalleSubPreguntaDJ/DetalleSubPreguntaDJ'

const DetalleDeclaracionJurada = ({ state, setState, paginaActual }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(userAux => userAux.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospectoAux => prospectoAux.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacionAux => cotizacionAux.isSelected || cotizacionAux.completado)[0]

    const initialState = {
        preguntas: []
    }

    const [localState, setLocalState] = useState(initialState)

    const obtenerMostrarDetalle = (pregunta) => {
        return pregunta.respuestaRapida === 1
    } 

    useEffect(() => {
        const obtenerRespuestaRapida = (pregunta) => {
            if (pregunta.respuestaRapida === null || pregunta.respuestaRapida === undefined || pregunta.respuestaRapida === -1) {
                let respuesta = state[paginaActual].subRespuestas.filter(respuestaAux => respuestaAux.idBancoPregunta === pregunta.idBancoPregunta
                    && (respuestaAux.respuesta === 1 || respuestaAux.respuesta === 0))[0]
                if (respuesta !== undefined && respuesta !== null) {
                    return respuesta.respuesta
                } else {
                    return -1
                }
            } else {
                if (paginaActual === 'contratante') {
                    if (state.contratante.subRespuestas !== undefined && state.contratante.subRespuestas !== null) {
                        return pregunta.respuestaRapida
                    } else {
                        return -1
                    }
                } else {
                    return pregunta.respuestaRapida
                }
            }
        }

        const cargarSubpreguntas = () => {
            let preguntas = []
            cotizacion.subpreguntas.map((pregunta) => {
                let retorna = false
                let tipoDetalle = null
                Globales.SUBPREGUNTAS_INICIALES.map(subPregunta => {
                    if (subPregunta.codigo === pregunta.idBancoPregunta) {
                        retorna = true
                        tipoDetalle = subPregunta.tipoDetalle
                    }
                    return subPregunta
                })

                if (retorna) {
                    //Armando Respuestas
                    pregunta.tipoDetalle = tipoDetalle
                    pregunta.respuestaRapida = obtenerRespuestaRapida(pregunta)
                    pregunta.mostrarDetalle = obtenerMostrarDetalle(pregunta)
                    preguntas.push(pregunta)
                }
                return pregunta
            })

            setLocalState((localStateAux) => {
                return {
                    ...localStateAux,
                    preguntas: preguntas
                }
            })

            setState((stateAux) => {
                return {
                    ...stateAux,
                    subPreguntas: preguntas
                }
            })
        }

        cargarSubpreguntas()
    }, [state.asegurado && state.asegurado.subRespuestas])

    const handleChangeSubPregunta = (pregunta, valorRespuesta) => {
        const cambiarRespuesta = () => {
            //Campo de Pregunta Local
            let preguntas = localState.preguntas.map(preguntaAux => {
                if (preguntaAux.idBancoPregunta === pregunta.idBancoPregunta) {
                    preguntaAux.respuestaRapida = valorRespuesta
                    preguntaAux.mostrarDetalle = obtenerMostrarDetalle(pregunta)
                }
                return preguntaAux
            })
            setLocalState((localStateAux) => {
                return {
                    ...localStateAux,
                    preguntas: preguntas
                }
            })

            //Cambio de Pregunta
            let respuestaEncontrada = false
            let subRespuestas = state[paginaActual].subRespuestas.map(respuesta => {
                if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                    respuesta.respuesta = valorRespuesta
                    respuestaEncontrada = true
                }
                return respuesta
            })

            if (!respuestaEncontrada) {
                if (subRespuestas.length > 0) {
                    subRespuestas.push({
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta,
                        detalle: []
                    })
                } else {
                    subRespuestas = [{
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta,
                        detalle: []
                    }]
                }
            }

            let detalle2Limpio = [
                {
                  pais: null,
                  NIT: null
                }
            ]

            setState((stateAux) => {
                return {
                    ...stateAux,
                    [paginaActual]: {
                        ...stateAux[paginaActual],
                        subRespuestas: subRespuestas
                    },
                    detalle1: (pregunta.idBancoPregunta === 57 || pregunta.idBancoPregunta === 59) && valorRespuesta === 0 ? 
                        {NIT: null} : stateAux.detalle1,
                    detalle2: (pregunta.idBancoPregunta === 58 || pregunta.idBancoPregunta === 60) && valorRespuesta === 0 ? 
                        detalle2Limpio : stateAux.detalle2,
                    noTieneNIT: (pregunta.idBancoPregunta === 58 || pregunta.idBancoPregunta === 60) && valorRespuesta === 0 ?
                        0 : stateAux.noTieneNIT,
                    noTieneNITDesc: (pregunta.idBancoPregunta === 58 || pregunta.idBancoPregunta === 60) && valorRespuesta === 0 ?
                        null : stateAux.noTieneNITDesc,
                    campoValidado: {
                        ...stateAux.campoValidado,
                        NIT1: (pregunta.idBancoPregunta === 57 || pregunta.idBancoPregunta === 59) && valorRespuesta === 0 ?
                            true : stateAux.campoValidado.NIT1,
                        pais: (pregunta.idBancoPregunta === 58 || pregunta.idBancoPregunta === 60) && valorRespuesta === 0 ?
                            [] : stateAux.campoValidado.pais,
                        NIT: (pregunta.idBancoPregunta === 58 || pregunta.idBancoPregunta === 60) && valorRespuesta === 0 ?
                            [] : stateAux.campoValidado.NIT,
                        noTieneNIT: (pregunta.idBancoPregunta === 58 || pregunta.idBancoPregunta === 60) && valorRespuesta === 0 ?
                            true : stateAux.campoValidado.noTieneNIT,
                        noTieneNITDesc: (pregunta.idBancoPregunta === 58 || pregunta.idBancoPregunta === 60) && valorRespuesta === 0 ?
                            true : stateAux.campoValidado.noTieneNITDesc
                    }
                }
            })

            if (valorRespuesta === 0) limpiarSubpregunta(pregunta.idBancoPregunta, valorRespuesta)
        }

        cambiarRespuesta()
    }

    const limpiarSubpregunta = (codigo) => {
        if (state[paginaActual].subRespuestas.length === 2) {
            state[paginaActual].subRespuestas.map(sub => {
                if (sub.idBancoPregunta === codigo) {
                    sub.detalle = []
                }
                return sub
            })
        }
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }

    return (
        <React.Fragment>
            <div className={styles.contenedor}>
                {localState.preguntas.map((pregunta, index) => {
                    return (
                        <div key={index} className={styles.adicionalPregunta}>
                            <div className={styles.grupo}>
                                <div>{index === 0 ? 'a' : index === 1 ? 'b' : ''}.</div>
                                <div className={styles.pregunta}>
                                    {pregunta.descripcion}
                                </div>
                                <div className={styles.opciones}>
                                    <form>
                                        <div className={styles.optionLight}>
                                            <label className={styles.labelRadio}>
                                                <input
                                                    type="radio"
                                                    name="sublight"
                                                    value="true"
                                                    checked={(state.contratante && state.contratante.subRespuestas === undefined ? false : pregunta.respuestaRapida === 1)
                                                        || pregunta.respuestaRapida === 1
                                                    }
                                                    selected={(state.contratante && state.contratante.subRespuestas === undefined ? false : pregunta.respuestaRapida === 1)
                                                        || pregunta.respuestaRapida === 1
                                                    }
                                                    onChange={(e) => handleChangeSubPregunta(pregunta, 1)}
                                                    disabled={Deshabilitar() !== true ? false : true}
                                                />
                                                <span className={`span-radio-si-no ${styles['radio-label']}`}>Si</span>
                                            </label>
                                            <label className={styles.labelRadio}>
                                                <input
                                                    type="radio"
                                                    name="sublight"
                                                    value="false"
                                                    checked={(state.contratante && state.contratante.subRespuestas === undefined ? false : pregunta.respuestaRapida === 0)
                                                        || pregunta.respuestaRapida === 0
                                                    }
                                                    selected={(state.contratante && state.contratante.subRespuestas === undefined ? false : pregunta.respuestaRapida === 0)
                                                        || pregunta.respuestaRapida === 0
                                                    }
                                                    onChange={(e) => handleChangeSubPregunta(pregunta, 0)}
                                                    disabled={Deshabilitar() !== true ? false : true}
                                                />
                                                <span className={`span-radio-si-no ${styles['radio-label']}`}>No</span>
                                            </label>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {pregunta !== undefined && pregunta.mostrarDetalle && pregunta.respuestaRapida === 1 ?
                                <div>
                                    <DetalleSubPreguntaDJ
                                        state={state}
                                        setState={setState}
                                        tipo={pregunta.tipoDetalle}
                                        pregunta={pregunta}
                                    />
                                </div>
                                : null
                            }
                        </div>
                    )
                })}
            </div>
        </React.Fragment>
    )
}

export default DetalleDeclaracionJurada